
import {Component, Prop, Vue} from "vue-property-decorator";
import {dataFieldsEditModule} from "@/store";
import DataFieldCache from "../../../models/data.field.cache";
import DataFieldBar from "@/components/study/datafields/base/DataFieldBar.vue";
import {stringify} from "@/auxillary/datafield.stringify";
import Hints from "@/components/study/datafields/base/Hints.vue";

@Component({
  name: 'DisplayValue',
  components: {
    DataFieldBar, Hints
  },
})
export default class DisplayValue extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache

  errorMessage: string = "";

  get displayName() {
    if (!this.dataField.displayName) return ""
    return this.dataField.displayName + (this.isRequired ? "<span style='color:red;'>*</span>" : "");
  }

  get isVisible() {
    return this.field.isVisible;
  }

  get isRequired() {
    return this.dataField.isRequired;
  }

  get value() {
    return this.dataField.values.value;
  }

  get fieldDefinitionType(){
    return this.dataField.values.definitionType || "DisplayValue";
  }

  set value(value: string) {
    dataFieldsEditModule.setValue({field: this.dataField, key: "value", value})
  }

  stringifyValue() {
    return stringify(this.field);
  }

  get field() {
    return this.dataField;
  }

}
